$(document).ready(function() {
  var adshop = '.ph-addproductsto_newlist';
  var $contentBlockTwo = 'cboxLoadedContent';
  var $elmtBlockTwo = 'addproductsto_newlist';

  $(document).on('click', '.ph-saveorder', function(event) {
  /* eslint-disable xss/no-mixed-html */
    event.preventDefault();
    $.colorbox({
      html: '<div id="popup-cart">' + $('.ph-addtoshoppinglist-container').html() + '</div>',
      width: '80%',
      maxWidth: 840,
      minWidth: 280,
      scrolling: false,
      top: 50,
      minHeight: 730,
      maxHeight: '80%',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('.ph-newlistcreation_field').css('display', 'none');

        $(adshop).click(function() {
          $('#cboxLoadedContent').find('.ph-savetolistBtn').removeClass('disabled');

          if ($(window).width() < 500) {
            $('#' + $contentBlockTwo).find('.ph-' + $elmtBlockTwo).css('display', 'none');
          }

          $('.ph-newlistfield_removedisable').removeAttr('disabled');
          $('.ph-newlistcreation_field').css('display', 'block');
          $('.ph-newlistcreation_field').focus();
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    $(document).on('click', '.addtoshoppinglist .ph-listname', function() {
      $(this).parent().find('.ph-checkmark').trigger('click');
    });
  });


  $('.ph-addproductsto_newlist').click(function() {
    $('#cboxLoadedContent').find('.ph-cart-savetolistBtn').removeClass('disabled');


    if ($(window).width() < 500) {
      $('#' + $contentBlockTwo).find('.ph-' + $elmtBlockTwo).css('display', 'none');
    }


    $('.ph-newlistfield_removedisable').removeAttr('disabled');
    $('.ph-newlistcreation_field').css('display', 'block');
    $('.ph-newlistcreation_field').focus();
  });


  function enableInputField() {
    var listName = $(this).parent().find('input').val();
    var $inputEl = $('#ph-newList-cart');


    if (listName === 'newList') {
      $inputEl.removeAttr('disabled');
      $inputEl.focus();
    } else {
      $inputEl.val('');
      $inputEl.attr('disabled', 'disabled');
      $('.ph-newlistcreation_field').css('display', 'none');
    }

    $('#cboxLoadedContent').find('.ph-cart-savetolistBtn').removeClass('disabled');

    if ($(window).width() < 500) {
      $('#' + $contentBlockTwo).find('.ph-' + $elmtBlockTwo).css('display', 'block');
    }
  }


  $(document).on('click', '#ph-shopping-rdo-btn', function() {
    $('.ph-newlistcreation_field').css('display', 'block');
    $('.ph-newlistcreation_field').focus();
    $('#cboxLoadedContent').find('.ph-cart-savetolistBtn').removeClass('disabled');
    $('input:checked').removeAttr('checked');
  });

  $(document).on('click', '#ph-cart-shopping-rdo-btn', function() {
    enableInputField();
  });

  $(document).on('click', '.ph-listname', function() {
    enableInputField();
  });

  function alreadyExistedList(listNumber, listObj) {
    $(this).find('#ph-existingList-' + listNumber).find('#prodCount').text(listObj.orderProductCount);
  }


  $(document).on('click', '#ph-cart-savetolistBtn', function() {
    var $selRdoEl = $('#ph-shoppinglistRdo:checked');
    var listname = '';
    var updatedCount = '';
    var $parentEl = '';
    var $popupCart = $('#popup-cart');
    var $validation = $('#popup-cart').find('#ph-newList-cart').val();


    if ($selRdoEl.length > 0) {
      listname = $selRdoEl.val();
      $.ajax({
        url: ACC.config.encodedContextPath + '/shoppinglist/storeCart',
        data: {
          shoppingListName: listname
        },
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          var listObj = $.parseJSON(JSON.stringify(result));

          updatedCount = listObj.orderProductCount;
          $selRdoEl.parent().next().find('#prodCount').val(updatedCount);
          $('.ph-addtoshoppinglist-container #ph-existingList-' +
            $selRdoEl.attr('data-listnumber')).find('#prodCount').html('&emsp14;(' + updatedCount +
            '<span class="ph-productstextsm">&emsp14;Products</span>)');

          $.colorbox.close();
        },
        error: function() {
          PHI.shoppinglist.enableCreateNewList();
        }
      });
    } else if ($validation.trim() === '' || (/[&\\#,+()=|`$@!~%.'":*?^<>{}]/g).test($validation) === true) {
      $parentEl = $popupCart.find('.ph-createnewlist-txt');

      $parentEl.find('input').addClass('ph-error-border');
      $parentEl.find('.ph-exclamation-mark').show();
      $parentEl.find('.ph-newlist-empty-validation').show('');
    } else {
      listname = $popupCart.find('#ph-newList-cart').val();

      $.ajax({
        url: ACC.config.encodedContextPath + '/shoppinglist/storeCart',
        data: {
          shoppingListName: listname
        },
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          var listObj = $.parseJSON(JSON.stringify(result));
          var isAlreadyExists = false;
          var listNumber = 0;
          var length = $('#cboxLoadedContent .addtoshoppinglist li').length;
          var listNameIt = '';

          for (listNumber; listNumber < length - 1; listNumber = listNumber + 1) {
            listNameIt = $('#cboxLoadedContent .addtoshoppinglist #ph-existingList-' + listNumber).attr('data-listName');


            if (result.orderName.toLowerCase() === listNameIt.toLowerCase()) {
              isAlreadyExists = true;

              break;
            }
          }

          $('.ph-addtoshoppinglist-container').each(function() {
            if (isAlreadyExists) {
              alreadyExistedList(listNumber, listObj);
            } else {
            /* eslint-disable max-len */
              $('.addtoshoppinglist').prepend('<li class = "rl-trim ph-addtoshoppinglistli" id="ph-existingList-' + listNumber + '" data-listName = "' + listObj.orderName + '">' +
              '<label class="ph-radiocontainer ph-float-left">' +
              '<input type="radio" class="ph-shoppinglistRdo" data-listNumber="' + listNumber + '" id="ph-shoppinglistRdo"  value="' + listObj.orderName + '" name="b2bUnit">' +
              '<span class="ph-checkmark" id="ph-cart-shopping-rdo-btn"></span>' +
              '</label>' +
              '<div class="ph-listnameoutersm" ><div class="ph-listnamesm"><span class="ph-listname">' + listObj.orderName +
              '</span> </div><div class="ph-listproductcountsm"><span id="prodCount">&emsp14;(' +
              listObj.orderProductCount + '<span class="ph-productstextsm">&emsp14;Products</span>)</span></div></div>' +
              '</li>');
            }
          });
          /* eslint-enable max-len */
          /* eslint-enable xss/no-mixed-html */
          $.colorbox.close();
        },
        error: function() {
          PHI.shoppinglist.enableCreateNewList();
        }
      });
    }
  });


  $(document).on('click', '.ph-btn-cont .ph-addtolist-cancel', function() {
    $.colorbox.close();
  });
});
